import React, { useState, useEffect } from 'react';

const BACKGROUND_BEAM_COUNT = 60;

const BackgroundScene = ({
  beamCount = BACKGROUND_BEAM_COUNT,
  isExiting = false,
}) => {
  const [beams, setBeams] = useState([]);

  useEffect(() => {
    const generated = Array.from({ length: beamCount }).map((_, i) => {
      const riseDur = Math.random() * 6 + 10;   // 10–16s rise (slower)
      const fadeDur = riseDur;                  // sync fade
      const dropDur = Math.random() * 3 + 3;

      const leftPos = Math.random() * 100;

      return {
        id: i,
        style: {
          left: `${leftPos}%`,
          width: `${Math.floor(Math.random() * 4) + 1}px`,
          // Negative delay makes animations start instantly, already in-progress
          animationDelay: `-${Math.random() * 15}s`,
          animationDuration: `${riseDur}s, ${fadeDur}s, ${dropDur}s`,
        },
      };
    });
    setBeams(generated);
  }, [beamCount]);

  return (
    <div className="scene" role="img" aria-label="Animated digital data background">
      <div className="bottom-glow" />
      
      {/* 3D Grid Floor */}
      <div className={`floor ${isExiting ? 'is-exiting' : ''}`} />
      
      <div className="main-column" />
      
      <div className="light-stream-container">
        {/* Continuous glow beam perfectly aligned with the center logo */}
        <div className={`major-beam ${isExiting ? 'is-exiting' : ''}`} />
        
        {/* Animated rising beams, wrapped in a single container for smooth downwards exit sweep */}
        <div className={`all-beams-wrapper ${isExiting ? 'is-exiting' : ''}`}>
          {beams.map((beam) => (
            <div 
              key={beam.id} 
              className="light-beam"
              style={beam.style}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BackgroundScene;
